/**
 * Created by claude on 2/13/26
 */

Map2dLocation.prototype.setupMerge3 = function () {
    this.tutorial = new MergeTutorial();
};

Map2dLocation.prototype.setupMerge3Planners = function () {
    this.pixelsPlanner = new PixelsPlanner(this.slot);
    this.friendPixelsPlanner = new FriendPixelsPlanner();
    this.barrelPlanner = new BarrelPlanner(this.slot);
    this.monstersPlanner = new MonstersPlanner(this.slot);
    this.growingsPlanner = new GrowingsPlanner(this.slot);
    this.shipsPlanner = new ShipsPlanner();
};

Map2dLocation.prototype.registerMerge3Stages = function () {
    this.counter.registerStage(24, this.monstersPlanner.processFresh.bind(this.monstersPlanner));
    this.counter.registerStage(30, this.tutorial.processFresh.bind(this.tutorial));
    this.counter.registerStage(50, this.tutorial.nextStep.bind(this.tutorial));
};

Map2dLocation.prototype.initMerge3 = function () {
    this.shipsPlanner.init();
};

Map2dLocation.prototype.initStageMerge3 = function () {
    this.monstersPlanner.removeWrongMonsters();
};

Map2dLocation.prototype.destroyMerge3 = function () {
    this.tutorial.destructor();
    this.pixelsPlanner && this.pixelsPlanner.destructor();
    this.friendPixelsPlanner && this.friendPixelsPlanner.destructor();
    this.barrelPlanner.destructor();
    this.monstersPlanner.destructor();
    this.growingsPlanner.destructor();
};

Map2dLocation.prototype.getMergeTutorial = function (key) {
    return MergeTutorials[key];
};

Map2dLocation.prototype.triggerBuildTutorial = function (unit) {
    Merge3BuildTutorial.TriggerBuildTutorial(unit);
};

Map2dLocation.prototype.removeUnitsInFog = function () {
    const removeUnits = [];
    const highlightedUnits = [];

    for (let y = 0; y < this.map.getHeight(); y++) {
        for (let x = 0; x < this.map.getWidth(); x++) {
            let unit = this.map.getUnit(x, y);
            const fog = this.map.getFog(x, y);
            if (unit && fog) {
                if (unit.isMultiCellBody()) {
                    unit = unit.head;
                }

                if (fog.fromBlockedGround()) {
                    continue;
                }

                cleverapps.metrics.logEvent(cleverapps.EVENTS.DEBUG.UNITS_IN_FOG + this.location.locationId);

                const message = `unit in fog: ${unit.code} ${unit.stage} at (${fog.x}, ${fog.y}) fogBlock: ${fog && fog.fogBlock && fog.fogBlock.id}`;

                if (cleverapps.config.debugMode) {
                    if (!highlightedUnits.includes(Unit.GetKey(unit))) {
                        highlightedUnits.push(Unit.GetKey(unit));

                        if (!this.fogErrorUnits) {
                            this.fogErrorUnits = [];
                        }
                        this.fogErrorUnits.push({ unit, message });
                    }
                } else {
                    cleverapps.throwAsync({ group: "UnitsInFog", message });
                }
            }
        }
    }

    if (removeUnits.length) {
        this.pocket.addUnits(removeUnits);
    }
};

Map2dLocation.prototype.restoreKickOuts = function () {
    const merge3saver = cleverapps.unitsSyncers.getInstance(this.slot.slotId).merge3saver;
    const units = merge3saver.loadKickOuts(this.location.families);

    const remains = [];
    units.forEach((info) => {
        if (info.data.code === "unknown") {
            return;
        }

        cleverapps.metrics.logEvent(cleverapps.EVENTS.DEBUG.UNITS_KICKED_OUT + this.location.locationId);

        const message = `unit was kicked out ${info.data.code} ${info.data.stage} ${info.x} ${info.y}`;

        if (cleverapps.config.debugMode) {
            if (!Map2dLocation.ignoreUnitsInFog) {
                if (confirm(`${message}\n\nMap is probably under editing. Ignore units in fog errors for this session?`)) {
                    Map2dLocation.ignoreUnitsInFog = true;
                } else {
                    throw new Error(message);
                }
            }
        } else {
            cleverapps.throwAsync({ group: "UnitsKickedOut", message });
        }

        const empty = this.map.findEmptySlot(info.x, info.y);
        if (!empty) {
            remains.push(info.data);
            return;
        }

        info.x = empty.x;
        info.y = empty.y;

        const unit = this.map.createUnit(info.x, info.y, info.data);
        if (unit) {
            this.map.onUnitAvailable(unit);
        }
    });

    if (remains.length > 0) {
        this.pocket.addUnits(remains);
    }

    merge3saver.resetKickOuts();
};

Map2dLocation.prototype.checkReset = function () {
    if (connector.synchronizer.corrupted) {
        return;
    }

    const units = cleverapps.createSet(this.map.listAvailableUnits().map(Unit.GetKey));

    const types = [cleverapps.unitsLibrary.getExpeditionUnitType("hero")];
    types.push("resource");

    const codes = cleverapps.unitsLibrary.listCodesByType(types);

    const resetedCodes = codes.filter((code) => {
        const unit = {
            code,
            stage: Families[code].units.length - 1
        };
        return cleverapps.unitsLibrary.isOpened(unit) && !units[Unit.GetKey(unit)];
    });

    const reseted = resetedCodes.length > 0;

    const storeKey = DataLoader.TYPES.RESET_REPORT + this.slot.slotId;

    if (!reseted) {
        cleverapps.dataLoader.remove(storeKey);
    } else if (!cleverapps.dataLoader.load(storeKey)) {
        cleverapps.dataLoader.save(storeKey, Date.now());

        console.log("save reset event", resetedCodes);

        cleverapps.RestClient.post(`/units/saveresetevent/${encodeURIComponent(connector.platform.getUserID())}`, {
            source: connector.info.source,
            codes: resetedCodes
        });
    }
};